import AdminResellersModule from '@/modules/admin-resellers';

const AdminResellers = () => {
  return <AdminResellersModule />;
};

export default AdminResellers;
